import axios from "axios";
import { config } from "./index";

const instance = axios.create({
  baseURL: config.apiHost,
  withCredentials: config.axiosWithCredentials,
});

export default instance;
